import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import {
  Table,
  Container,
  Row,
  Col,
  Button,
  Form,
  InputGroup,
  Navbar,
  Nav,
} from "react-bootstrap";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import "../css/DistributionForm.css";
import Footer from "./Footer";
import { useEmployeesContext } from "../hooks/useEmployeesContext";
import { useEffect, useState } from "react";
import { ThemeContext } from "../context/ThemeContext";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { useAuthContext } from "../hooks/useAuthContext";

// import QA objects

function DistributionForm() {

  // Distribution Session--------
  const [error, seterror] = useState(null);
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [locate, setLocate] = useState('');


  const { user } = useAuthContext();

  //------------------------------



  //Getting the QA Session id
  const location = useLocation();
  const { RevID } = location.state;

  // QA object---------------------------------------------------

  const [QASession, setQASession] = useState();
  const [isFetched, setIsFetched] = useState(false);

  useEffect(() => {
    const handleQAItem = async () => {
      console.log(RevID);
      const response = await fetch("/api/qualityassurance/" + RevID, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user.token}`,
        }
      });
      const json = await response.json();

      if (response.ok) {
        setQASession(json);
        setIsFetched(true);
      }
    };

    handleQAItem();
  }, [RevID]);

  //----------------------------------------------------------

  const { transportDriver, globaldistance, globalduration } =
    useContext(ThemeContext);




  //=================== handle Submit =========================

  const handleSubmit = async (e) => {
    e.preventDefault();

    const DSitem = {
      category: QASession.category,
      batchNo: QASession.batchNo,
      quantity: QASession.quantity,
      locate: locate,
      distance: globaldistance,
      duration: globalduration,
      driverID: transportDriver._id,
      date: date,
      time: time,
    };



    const response = await fetch("/api/distributions", {
      method: "POST",
      body: JSON.stringify(DSitem),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
    });

    const json = await response.json();

    if (!response.ok) {
      seterror(json.error);
    }
    if (response.ok) {
      seterror(null);
      console.log("Distribution Session Created");
    }

  }



  //==========================================================

  return (
    <div>
      <div className="entire-form-section">
        {/* -------------------------------------------------- */}
        {/* ---------- ####### NAV BAR START #######---------- */}
        {/* -------------------------------------------------- */}
        <Navbar
          collapseOnSelect
          expand="lg"
          variant="dark"
          sticky="top"
          className="nav-bar-edit"
        >
          <Container>
            <Navbar.Brand>Distribution Form</Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-auto"></Nav>
              <Nav>
                {user && (
                  <div>
                    <Navbar.Text className="nav-component nav-user-name-emp">
                      <b>Signed as: </b> {user.email}
                    </Navbar.Text>
                    <Navbar.Text className="nav-component nav-user-name-emp">
                      <b>Role: </b> {user.role}
                    </Navbar.Text>
                  </div>
                )}
                <Link
                  to="/dashboard"
                  className="btn btn-primary mr-2 nav-component nav-link-btn "
                >
                  Dashboard
                </Link>
                <Link
                  to="/DistributionCards"
                  className="btn btn-primary mr-2 nav-component nav-link-btn "
                >
                  Distribution Cards
                </Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        {/* ------------------------------------------------ */}
        {/* ---------- ####### NAV BAR END #######---------- */}
        {/* ------------------------------------------------ */}

        <div className="content">
          <h1 className="table-name">
            <span>Distribution Form</span>
          </h1>
          <h2 className="table-info">

          </h2>

          <div className="form-center">
            {/* ----------------------------------------------- */}
            {/* ---------- ####### FORM START #######---------- */}
            {/* ----------------------------------------------- */}
            <Form className="p-4 p-sm-4 filter-section filter-form">


              {/* QA Section start*/}

              <Row>
                <Col>
                  <Form.Group
                    className="mb-4 form-field"
                    controlId="formCategory"
                  >
                    <Form.Label>Category</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="Category"
                        value={isFetched ? QASession.category : "Loading..."}
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-4 form-field" controlId="formBatch">
                    <Form.Label>Batch</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="Batch"
                        value={isFetched ? QASession.batchNo : "Loading..."}
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Group
                    className="mb-4 form-field"
                    controlId="formQuantity"
                  >
                    <Form.Label>Quantity</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="number"
                        placeholder="Quantity"
                        value={isFetched ? QASession.quantity : "Loading..."}
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group className="mb-4 form-field" controlId="formMap">
                    <Form.Label>Location</Form.Label>
                    <InputGroup>
                      <Form.Control type="text" placeholder="Location"
                        onChange={(e) => setLocate(e.target.value)}
                        value={locate}
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col>
                  <Link to="/NewMap">
                    <button
                      type="submit"
                      className="btn btn-primary btn-padding distribution-btn"
                    >
                      View map
                    </button>
                  </Link>
                </Col>
              </Row>

              {/* <Row>
                                <Col>
                                    <Form.Group className="mb-4 form-field" controlId="formQuantity">
                                        <Form.Label>Quantity</Form.Label>
                                        <InputGroup>
                                            <Form.Control
                                                type="number"
                                                placeholder="Quantity"
                                            />
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row> */}

              <Row>
                <Col>
                  <Form.Group
                    className="mb-4 form-field"
                    controlId="formDistance"
                  >
                    <Form.Label>Distance(km)</Form.Label>
                    <span>
                      {/* <Form.Control type="number" placeholder="Distance" value={ globaldistance} /> */}
                      {globaldistance}
                    </span>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group
                    className="mb-4 form-field"
                    controlId="formDuration"
                  >
                    <Form.Label>Duration(hrs)</Form.Label>
                    <span>
                      {/* <Form.Control type="number" placeholder="Duration" value={ globaldistance} /> */}
                      {globalduration}
                    </span>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Group
                    className="mb-4 form-field"
                    controlId="formDriverID"
                  >
                    <Form.Label>Driver ID</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="Driver ID"
                        value={transportDriver && transportDriver._id}
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col>
                  <Link to="/DistributionEmpTable" state={{ RevID: RevID }}>
                    <button
                      type="submit"
                      className="btn btn-primary btn-padding distribution-btn"
                    >
                      View drivers
                    </button>
                  </Link>
                </Col>


                {/* Vehicle ID */}

                {/* <Col>
                  <Form.Group
                    className="mb-4 form-field"
                    controlId="formVehicleID"
                  >
                    <Form.Label>Vehicle ID</Form.Label>
                    <InputGroup>
                      <Form.Control type="text" placeholder="Vehicle ID" />
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col>
                  <Link to="/distribution/emptable">
                    <button
                      type="submit"
                      className="btn btn-primary btn-padding distribution-btn"
                    >
                      View vehicles
                    </button>
                  </Link>
                </Col> */}


              </Row>



              <Row>
                <Col>
                  <Form.Group className="mb-4 form-field" controlId="formDate">
                    <Form.Label>Date</Form.Label>
                    <InputGroup>
                      <Form.Control type="date" placeholder="Select the date"
                        onChange={(e) => setDate(e.target.value)}
                        value={date}
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-4 form-field" controlId="formTime">
                    <Form.Label>Time</Form.Label>
                    <InputGroup>
                      <Form.Control type="text" placeholder="Time"
                        onChange={(e) => setTime(e.target.value)}
                        value={time}
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
              </Row>


              <div className="d-grid gap-2">
                <Link to={"/DistributionCards"}>
                  <Button variant="success" type="Submit" className="filter-btn"
                    onClick={(e) => {
                      handleSubmit(e);

                    }}
                  >
                    Submit Distribution Form
                  </Button>
                </Link>
              </div>
            </Form>
            {/* --------------------------------------------- */}
            {/* ---------- ####### FORM END #######---------- */}
            {/* --------------------------------------------- */}
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}

export default DistributionForm;
